<template>
  <div style="width: 100%">
    <!-- TBC Material Banner -->
    <v-alert v-if="showTbcBanner" type="warning" color="accent" class="d-flex align-center justify-center mb-4">
      <template v-slot:prepend>
        <div class="tbc-icon-container d-flex align-center justify-center mr-4">
          <v-icon color="accent" size="16" class="mt-1">mdi-exclamation</v-icon>
        </div>
      </template>
      <strong>This version has material colour that is set To Be Confirmed (TBC)</strong>
    </v-alert>

    <div id="quote-view" class="pa-sm-6">
      <v-alert v-if="$vuetify.display.xs && !order" type="info" class="text-caption"
        >You are viewing the mobile version of your quote. Please view on a larger screen to access the visual and place
        your order.</v-alert
      >

      <!-- HEADER -->
      <v-container fluid class="mb-4">
        <v-row class="align-baseline mb-2 mb-sm-8">
          <v-col cols="12" sm="6" class="order-2 order-sm-1 text-center text-sm-left">
            <h1>{{ order ? 'Order' : 'Quotation' }}</h1>
            <div v-if="!order && version">
              <div v-if="version.title" class="text-h6 mt-2">{{ version.title }}</div>
              <div v-if="version.titleDesc" class="text-body-2 text-medium-emphasis mt-1">{{ version.titleDesc }}</div>
            </div>
          </v-col>
          <v-col cols="12" sm="6" class="order-1 order-sm-2 text-center text-sm-right">
            <img src="@/assets/final-logo-tight.png" alt="Plykea" :width="$vuetify.display.xs ? '30%' : '200px'" />
          </v-col>
        </v-row>

        <v-row v-if="order"> </v-row>

        <v-row>
          <v-col cols="6" class="py-1 order-sm-1">
            <div class="text-caption text-medium-emphasis">
              {{ order ? 'Order Number' : 'Date Created' }}
            </div>
          </v-col>
          <v-col cols="6" class="py-1 order-sm-3">
            <div class="text-body-2 text-right text-sm-left">
              {{
                order
                  ? order.orderNumber || order.xeroInvoiceNumber
                  : $moment($utils.ensureFirestoreTimestamp(version.pricing.dateCreated).toDate()).format('Do MMM YYYY')
              }}
            </div>
          </v-col>
          <v-col cols="6" class="py-1 order-sm-5">
            <div class="text-caption text-medium-emphasis">
              {{ order ? 'Created' : 'Expires' }}
            </div>
          </v-col>
          <v-col cols="6" class="py-1 order-sm-7">
            <div class="text-body-2 text-right text-sm-left">
              {{
                order
                  ? $moment.unix(order.dateCreated.seconds).format('Do MMM YYYY')
                  : $moment($utils.ensureFirestoreTimestamp(version.pricing.dateCreated).toDate())
                      .add(30, 'days')
                      .format('Do MMM YYYY')
              }}
            </div>
          </v-col>
          <v-col cols="6" class="py-1 order-sm-2">
            <div class="text-caption text-medium-emphasis text-left text-sm-right">Prepared By</div>
          </v-col>
          <v-col cols="6" class="py-1 text-right order-sm-4">
            <div class="text-body-2">{{ version.creatorEmail }}</div>
          </v-col>
          <v-col cols="6" class="py-1 order-sm-6">
            <div class="text-caption text-medium-emphasis text-left text-sm-right">Prepared For</div>
          </v-col>
          <v-col cols="6" class="py-1 text-right order-sm-8">
            <div class="text-body-2">{{ displayCustomerEmail }}</div>
          </v-col>
        </v-row>
      </v-container>

      <v-container fluid class="text-caption hidden-xs pb-0">
        <v-row>
          <v-col cols="8">Item</v-col>
          <v-col v-if="discountApplied" cols="1">Price</v-col>
          <v-col v-if="discountApplied" cols="1">Discount</v-col>
          <v-spacer />
          <v-col cols="1" class="text-right">Subtotal</v-col>
        </v-row>
      </v-container>

      <v-expansion-panels v-model="openLists" :multiple="customerView">
        <!-- FRONTS / COVER PANELS-->
        <v-expansion-panel
          v-for="material in requiredMaterialInfo"
          :value="material.id"
          :name="material.id"
          :key="material.id"
          :disabled="$vuetify.display.xs || material.thickness == 4 || isSimpleMaterialLine(material)"
        >
          <v-expansion-panel-title class="px-0 py-2 py-sm-4" hide-actions>
            <v-container fluid class="py-2">
              <v-row>
                <v-col :cols="discountApplied ? 10 : 8" sm="8">
                  <div class="text-sm-truncate text-body-2 text-sm-body-1">
                    <template v-if="isSimpleMaterialLine(material)"
                      >{{ material.colourCode }} {{ material.label }} {{ material.thickness }}mm{{
                        material.unfinished ? ' (unfinished)' : ''
                      }}</template
                    >
                    <template v-else>
                      <v-icon class="hidden-xs mr-1">mdi-chevron-down</v-icon
                      >{{ material.thickness == 4 ? 'Handle Inserts in ' : 'Fronts, cover panels and plinths in ' }}
                      {{ material.colourCode }} {{ material.label }} {{ material.thickness }}mm{{
                        material.unfinished ? ' (unfinished)' : ''
                      }}
                      <span v-if="material.thickness != 4" class="hidden-xs text-accent"
                        >(click for itemised list)</span
                      >
                    </template>
                  </div>
                </v-col>
                <v-col cols="4" sm="1" v-if="version.discount > 0 || discountApplied">
                  <div class="hidden-sm-and-up text-caption text-medium-emphasis">Price</div>
                  <div>
                    {{
                      version.pricing.fronts[material.id]
                        ? $numeral(version.pricing.fronts[material.id].total).format('$0,0.00')
                        : $numeral(0).format('$0,0.00')
                    }}
                  </div>
                </v-col>
                <v-col v-if="version.discount > 0 || discountApplied" cols="1">
                  <div class="hidden-sm-and-up text-caption text-medium-emphasis">Discount</div>
                  <div>{{ version.discount ? version.discount : 0 }}%</div>
                </v-col>
                <v-spacer />
                <v-col cols="4" sm="1" class="text-right">
                  <div class="hidden-sm-and-up text-caption text-medium-emphasis">Subtotal</div>
                  <div>
                    {{
                      version.pricing.fronts[material.id]
                        ? $numeral(version.pricing.fronts[material.id].total * (1 - version.discount / 100)).format(
                            '$0,0.00'
                          )
                        : $numeral(0).format('$0,0.00')
                    }}
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-expansion-panel-title>

          <v-expansion-panel-text v-if="$vuetify.display.smAndUp">
            <v-container fluid class="pa-0">
              <v-divider />
              <v-row class="text-caption">
                <v-col cols="1">Loc</v-col>
                <v-col cols="3">Item</v-col>
                <v-col cols="5">Feature / Handle</v-col>
                <v-col cols="2" class="text-truncate">Size ({{ quote.region == 'us' ? 'inch' : 'mm' }})</v-col>
                <v-col cols="1" class="text-right">Qty</v-col>
              </v-row>
              <v-divider class="mb-4" />

              <v-row v-for="front in byMaterial(frontsQuoteList, material.id)" :key="front.id" class="text-caption">
                <v-col cols="1" class="text-truncate">{{ front.itemNum }}</v-col>
                <v-col cols="3" class="text-truncate"
                  >{{ front.specialLabel ? front.specialLabel : productData.getFrontTypeLabel(front.frontType)
                  }}{{
                    front.joiningPos && ['top', 'mid', 'bot'].includes(front.joiningPos)
                      ? ' (' + getPositionName(front.joiningPos) + ')'
                      : ''
                  }}{{ getMaterialSides(front.material) == 1 ? ' [Single-Sided]' : '' }}</v-col
                >
                <v-col cols="5" class="text-truncate"
                  >{{ front.handle ? getHandleName(front.handle) + ' Handle' : 'N/A' }}
                </v-col>
                <v-col cols="2" class="text-truncate"
                  >{{ quote.region == 'us' ? parseFloat($utils.mmToInch(front.w)) : front.w }}
                  x
                  {{ quote.region == 'us' ? parseFloat($utils.mmToInch(front.h)) : front.h }}
                </v-col>
                <v-col cols="1" class="text-right">{{ front.qty }}</v-col>
              </v-row>

              <v-row
                v-for="coverPanel in byMaterial(version.coverPanels, material.id)"
                :key="coverPanel.id"
                class="text-caption"
              >
                <v-col cols="1" class="text-truncate">{{ coverPanel.itemNum }}</v-col>
                <v-col cols="3" class="text-truncate"
                  >{{ productData.getCoverPanelTypeLabel(coverPanel.coverPanelType)
                  }}{{ getMaterialSides(coverPanel.material) == 1 ? ' [Single-Sided]' : '' }}</v-col
                >
                <v-col cols="5" class="d-flex align-center">
                  <span v-if="coverPanel.lighting">
                    {{ coverPanel.lighting }}mm Lighting
                    {{
                      coverPanel.lightingRef === 'r'
                        ? `from the Right ${coverPanel.lightingOffset}mm`
                        : coverPanel.lightingRef === 'l'
                        ? `from the Left ${coverPanel.lightingOffset}mm`
                        : 'Centered'
                    }}
                  </span>
                  <span v-else-if="coverPanel.coverPanelType === 'v-plinth' && coverPanel.vent">
                    {{ coverPanel.vent }}mm Vent from the {{ coverPanel.ventRef === 'r' ? 'Right' : 'Left' }}
                    {{ coverPanel.ventOffset }}mm
                  </span>
                  <span v-else-if="!hasEdgeTreatment(coverPanel)">n/a</span>
                  <!-- Edge Treatment Visual -->
                  <div
                    v-if="hasEdgeTreatment(coverPanel)"
                    class="edge-treatment-box"
                    :class="{ 'ml-3': coverPanel.lighting }"
                  >
                    <div class="label">Edge-banding</div>
                    <v-checkbox
                      hide-details
                      class="top ma-0 pa-0"
                      :disabled="true"
                      v-model="coverPanel.edges.top"
                    ></v-checkbox>
                    <v-checkbox
                      hide-details
                      class="bottom ma-0 pa-0"
                      :disabled="true"
                      v-model="coverPanel.edges.bottom"
                    ></v-checkbox>
                    <v-checkbox
                      hide-details
                      class="edge-left ma-0 pa-0"
                      :disabled="true"
                      v-model="coverPanel.edges.left"
                    ></v-checkbox>
                    <v-checkbox
                      hide-details
                      class="edge-right ma-0 pa-0"
                      :disabled="true"
                      v-model="coverPanel.edges.right"
                    ></v-checkbox>
                  </div>
                </v-col>
                <v-col cols="2" class="text-truncate"
                  >{{ quote.region == 'us' ? parseFloat($utils.mmToInch(coverPanel.w)) : coverPanel.w }}
                  x
                  {{ quote.region == 'us' ? parseFloat($utils.mmToInch(coverPanel.h)) : coverPanel.h }}</v-col
                >
                <v-col cols="1" class="text-right">{{ coverPanel.qty }} </v-col>
              </v-row>
            </v-container>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <!-- SPACER PANELS -->
        <v-expansion-panel v-if="version.spacerPanels.length > 0" :disabled="$vuetify.display.xs">
          <v-expansion-panel-title class="px-0 py-2 py-sm-4" hide-actions>
            <v-container fluid class="py-2">
              <v-row>
                <v-col :cols="discountApplied ? 10 : 8" sm="8">
                  <div class="text-sm-truncate text-body-2 text-sm-body-1">
                    <v-icon class="hidden-xs mr-1">mdi-chevron-down</v-icon>Spacer Panels
                    <span class="text-accent hidden-xs">(click for itemised list)</span>
                  </div>
                </v-col>
                <v-col cols="4" sm="1" v-if="version.discount > 0 || discountApplied">
                  <div class="text-caption hidden-sm-and-up text-medium-emphasis">Price</div>
                  <div class="text-body-2">
                    {{ $numeral(version.pricing.spacerPanels.totalPrice).format('$0,0.00') }}
                  </div>
                </v-col>
                <v-col cols="4" sm="1" v-if="version.discount > 0 || discountApplied">
                  <div class="text-caption hidden-sm-and-up text-medium-emphasis">Discount</div>
                  <div class="text-body-2">{{ version.discount ? version.discount : 0 }}%</div>
                </v-col>
                <v-spacer />
                <v-col cols="4" sm="1" class="text-right">
                  <div class="hidden-sm-and-up text-caption text-medium-emphasis">Subtotal</div>
                  <div>
                    {{
                      $numeral(version.pricing.spacerPanels.totalPrice * (1 - version.discount / 100)).format('$0,0.00')
                    }}
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-expansion-panel-title>

          <v-expansion-panel-text v-if="$vuetify.display.smAndUp">
            <v-divider />
            <v-row class="text-caption">
              <v-col cols="2">Location</v-col>
              <v-col cols="2">Material</v-col>
              <v-col cols="2">Length ({{ quote.region == 'us' ? 'inch' : 'mm' }})</v-col>
              <v-spacer />
              <v-col cols="2" class="text-right">Qty</v-col>
            </v-row>
            <v-divider class="mb-4" />

            <v-row v-for="(spacer, key) in version.spacerPanels" :key="key" class="text-caption">
              <v-col cols="2">{{ spacer.location }}</v-col>
              <v-col cols="2">{{ productData.getSpacerMaterial(spacer.material).label }}</v-col>
              <v-col cols="2">{{ quote.region == 'us' ? parseFloat($utils.mmToInch(spacer.l)) : spacer.l }}</v-col>
              <v-spacer />
              <v-col cols="2" class="text-right">{{ spacer.qty }}</v-col>
            </v-row>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <!-- WORKTOPS -->
        <v-expansion-panel
          v-if="version.worktops.length > 0 || version.pricing.worktops?.total > 0"
          :disabled="$vuetify.display.xs"
        >
          <v-expansion-panel-title class="px-0 py-2 py-sm-4" hide-actions>
            <v-container fluid class="py-2">
              <v-row>
                <v-col :cols="discountApplied ? 10 : 8" sm="8">
                  <div class="text-sm-truncate text-body-2 text-sm-body-1">
                    <v-icon class="hidden-xs mr-1">mdi-chevron-down</v-icon>Worktops
                    <span class="text-accent hidden-xs">(click for itemised list)</span>
                  </div>
                </v-col>
                <v-col cols="4" sm="1" v-if="version.discount > 0 || discountApplied">
                  <div class="text-caption hidden-sm-and-up text-medium-emphasis">Price</div>
                  <div class="text-body-2">
                    {{ $numeral(version.pricing.worktops.total).format('$0,0.00') }}
                  </div>
                </v-col>
                <v-col cols="4" sm="1" v-if="version.discountWorktops > 0 || discountApplied">
                  <div class="text-caption hidden-sm-and-up text-medium-emphasis">Discount</div>
                  <div class="text-body-2">{{ version.discountWorktops ? version.discountWorktops : 0 }}%</div>
                </v-col>
                <v-spacer />
                <v-col cols="4" sm="1" class="text-right">
                  <div class="hidden-sm-and-up text-caption text-medium-emphasis">Subtotal</div>
                  <div>
                    {{
                      $numeral(version.pricing.worktops.total * (1 - version.discountWorktops / 100)).format('$0,0.00')
                    }}
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-expansion-panel-title>

          <v-expansion-panel-text v-if="$vuetify.display.smAndUp">
            <v-divider />
            <v-row class="text-caption">
              <v-col cols="2">Section</v-col>
              <v-col cols="8">Section Information</v-col>
              <v-col cols="2" class="text-right">Material / Colour</v-col>
            </v-row>
            <v-divider class="mb-4" />

            <v-row v-if="version.worktops.length === 0" class="text-caption">
              <v-col cols="12" class="text-medium-emphasis">
                Worktop charge retained from the original price — the worktops have since been removed from this
                version's specification.
              </v-col>
            </v-row>

            <v-row v-for="worktop in version.worktops" :key="worktop.id" class="text-caption">
              <v-col cols="12">
                <v-row v-for="section in worktop.sections" :key="section.id" class="align-center my-2">
                  <v-col cols="2"
                    >{{ section.name }}{{ section.dogleg ? ' (Dogleg)' : ''
                    }}{{ section.customCoreThickness ? ' (Upstand)' : '' }}</v-col
                  >
                  <!-- Dimensions Box -->
                  <v-col cols="2" class="worktop-box-col px-4">
                    <div class="worktop-box" :class="{ 'has-dogleg': section.dogleg }">
                      <div :class="section.dogleg ? 'label-shifted' : 'label'">Dimensions</div>
                      <div class="depth">
                        {{ quote.region == 'us' ? parseFloat($utils.mmToInch(section.d)) : section.d }}
                      </div>
                      <div :class="section.dogleg ? 'length-shifted' : 'length'">
                        {{ quote.region == 'us' ? parseFloat($utils.mmToInch(section.l)) : section.l }}
                      </div>
                      <div class="innerBox" v-if="section.dogleg">
                        <div class="innerLabel">Dogleg</div>
                        <div class="doglegDepth">
                          {{ quote.region == 'us' ? parseFloat($utils.mmToInch(section.di)) : section.di }}
                        </div>
                        <div class="doglegLength">
                          {{ quote.region == 'us' ? parseFloat($utils.mmToInch(section.li)) : section.li }}
                        </div>
                      </div>
                    </div>
                  </v-col>
                  <!-- Radius Box -->
                  <v-col cols="2" class="worktop-box-col px-4">
                    <div class="worktop-box" :class="{ 'has-dogleg': section.dogleg }" v-if="section.radii">
                      <div :class="section.dogleg ? 'label-shifted' : 'label'">Radius (mm)</div>
                      <div class="bl">{{ section.radii.bl }}</div>
                      <div class="br">{{ section.radii.br }}</div>
                      <div class="fr">{{ section.radii.fr }}</div>
                      <div :class="section.dogleg ? 'fl-dog' : 'fl'">{{ section.radii.fl }}</div>
                      <div v-if="section.dogleg" class="fm-dog">{{ section.radii.fm }}</div>
                      <div class="innerBox" v-if="section.dogleg">
                        <div class="innerLabel">Dogleg</div>
                        <div class="i">{{ section.radii.i }}</div>
                      </div>
                    </div>
                  </v-col>
                  <!-- Finishing Box -->
                  <v-col cols="2" class="worktop-box-col px-4">
                    <div class="worktop-box" :class="{ 'has-dogleg': section.dogleg }" v-if="section.finished">
                      <div :class="section.dogleg ? 'label-shifted' : 'label'">Finishing</div>
                      <v-checkbox
                        hide-details
                        :class="section.dogleg ? 'front-shifted ma-0 pa-0' : 'front ma-0 pa-0'"
                        :disabled="true"
                        v-model="section.finished.front"
                      ></v-checkbox>
                      <v-checkbox
                        hide-details
                        class="back ma-0 pa-0"
                        :disabled="true"
                        v-model="section.finished.back"
                      ></v-checkbox>
                      <v-checkbox
                        hide-details
                        :class="section.dogleg ? 'left-shifted ma-0 pa-0' : 'edge-left ma-0 pa-0'"
                        :disabled="true"
                        v-model="section.finished.left"
                      ></v-checkbox>
                      <v-checkbox
                        hide-details
                        class="edge-right ma-0 pa-0"
                        :disabled="true"
                        v-model="section.finished.right"
                      ></v-checkbox>
                      <div class="innerBox" v-if="section.dogleg">
                        <div class="innerLabel">Dogleg</div>
                        <v-checkbox
                          hide-details
                          class="dogLong ma-0 pa-0"
                          :disabled="true"
                          v-model="section.finished.dogLong"
                        ></v-checkbox>
                        <v-checkbox
                          hide-details
                          class="dogShort ma-0 pa-0"
                          :disabled="true"
                          v-model="section.finished.dogShort"
                        ></v-checkbox>
                      </div>
                    </div>
                  </v-col>
                  <!-- Edge-banding Box -->
                  <v-col cols="2" class="worktop-box-col px-4">
                    <div class="worktop-box" :class="{ 'has-dogleg': section.dogleg }" v-if="section.edgeBanded">
                      <div :class="section.dogleg ? 'label-shifted' : 'label'">Edge-banding</div>
                      <v-checkbox
                        hide-details
                        :class="section.dogleg ? 'front-shifted ma-0 pa-0' : 'front ma-0 pa-0'"
                        :disabled="true"
                        v-model="section.edgeBanded.front"
                      ></v-checkbox>
                      <v-checkbox
                        hide-details
                        class="back ma-0 pa-0"
                        :disabled="true"
                        v-model="section.edgeBanded.back"
                      ></v-checkbox>
                      <v-checkbox
                        hide-details
                        :class="section.dogleg ? 'left-shifted ma-0 pa-0' : 'edge-left ma-0 pa-0'"
                        :disabled="true"
                        v-model="section.edgeBanded.left"
                      ></v-checkbox>
                      <v-checkbox
                        hide-details
                        class="edge-right ma-0 pa-0"
                        :disabled="true"
                        v-model="section.edgeBanded.right"
                      ></v-checkbox>
                      <div class="innerBox" v-if="section.dogleg">
                        <div class="innerLabel">Dogleg</div>
                        <v-checkbox
                          hide-details
                          class="dogLong ma-0 pa-0"
                          :disabled="true"
                          v-model="section.edgeBanded.dogLong"
                        ></v-checkbox>
                        <v-checkbox
                          hide-details
                          class="dogShort ma-0 pa-0"
                          :disabled="true"
                          v-model="section.edgeBanded.dogShort"
                        ></v-checkbox>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="2" class="text-right">
                    {{ section.customCoreThickness ? section.coreThickness + 'mm' : worktop.thickness + 'mm' }}
                    {{ worktop.material }} ({{ worktop.faces === 'single' ? 'Single-Sided' : 'Double-Sided' }})<br />
                    {{ findWorktopColourName(worktop) }} - {{ worktop.colourCode }}
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <!-- URTILS -->
        <v-expansion-panel v-if="version.urtils && version.urtils.length > 0" :disabled="$vuetify.display.xs">
          <v-expansion-panel-title class="px-0 py-2 py-sm-4" hide-actions>
            <v-container fluid class="py-2">
              <v-row>
                <v-col :cols="discountApplied ? 10 : 8" sm="8">
                  <div class="text-sm-truncate text-body-2 text-sm-body-1">
                    <v-icon class="hidden-xs mr-1">mdi-chevron-down</v-icon>Urtils
                    <span class="hidden-xs text-accent"> (click for itemised list)</span>
                  </div>
                </v-col>
                <v-col cols="4" sm="1" v-if="version.discount > 0 || discountApplied">
                  <div class="text-caption hidden-sm-and-up text-medium-emphasis">Price</div>
                  <div class="text-body-2">
                    {{ $numeral(version.pricing.urtils.total).format('$0,0.00') }}
                  </div>
                </v-col>
                <v-col cols="4" sm="1" v-if="version.discount > 0 || discountApplied">
                  <div class="text-caption hidden-sm-and-up text-medium-emphasis">Discount</div>
                  <div class="text-body-2">0%</div>
                </v-col>
                <v-spacer />
                <v-col cols="4" sm="1" class="text-right">
                  <div class="text-caption text-medium-emphasis hidden-sm-and-up">Subtotal</div>
                  <div>
                    {{ $numeral(version.pricing.urtils.total).format('$0,0.00') }}
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-expansion-panel-title>

          <v-expansion-panel-text v-if="$vuetify.display.smAndUp">
            <v-divider />
            <v-row class="text-caption text-truncate">
              <v-col cols="1">Name + Type</v-col>
              <v-col cols="2">Dimensions W/H/D</v-col>
              <v-col cols="1">Compartments</v-col>
              <v-col cols="2">Back</v-col>
              <v-col cols="2">Door 1</v-col>
              <v-col cols="2">Door 2</v-col>
              <v-col cols="1" class="text-right">Lighting</v-col>
              <v-col cols="1" class="text-right">Shelving</v-col>
            </v-row>
            <v-divider class="mb-4" />

            <v-row v-for="urtil in version.urtils" :key="urtil.id" class="text-caption">
              <v-col cols="1" class="text-wrap"
                >{{ urtil.name }} - {{ productData.getUrtilType(urtil.type).label.split(' ')[0] }} /
                {{ getMaterialName(urtil.carcass).split('/')[0]
                }}{{
                  urtil.preAssembled ? ' (Pre-Assembled)' : urtil.trimming ? ' (Trim-Fit)' : ' (Flat-Packed)'
                }}</v-col
              >
              <v-col cols="2" class="text-truncate">{{
                quote.region == 'us'
                  ? parseFloat($utils.mmToInch(urtil.w)) +
                    'in / ' +
                    parseFloat($utils.mmToInch(urtil.h)) +
                    'in / ' +
                    parseFloat($utils.mmToInch(urtil.d)) +
                    'in'
                  : urtil.w + 'mm / ' + urtil.h + 'mm / ' + urtil.d + 'mm'
              }}</v-col>
              <v-col cols="1" class="text-truncate">{{ urtil.compartments }}</v-col>
              <v-col cols="2" class="text-truncate">{{
                urtil.back ? getMaterialName(urtil.back).split('/')[0] : 'N/A'
              }}</v-col>
              <v-col cols="2" class="text-truncate"
                >{{
                  urtil.singleDoorSide && urtil.type == 's'
                    ? 'Right-Side '
                    : !urtil.singleDoorSide && urtil.type == 's'
                    ? 'Left-Side '
                    : ''
                }}{{ urtil.material1 && urtil.type !== 'o' ? getMaterialName(urtil.material1).split('/')[0] : 'N/A' }}
                {{ urtil.doorCoverageOne ? '[' + urtil.doorCoverageOne + ']' : '' }}</v-col
              >
              <v-col cols="2" class="text-truncate"
                >{{ urtil.material2 && urtil.type == 't' ? getMaterialName(urtil.material2).split('/')[0] : 'N/A' }}
                {{ urtil.doorCoverageTwo ? '[' + urtil.doorCoverageTwo + ']' : '' }}</v-col
              >
              <v-col cols="1" class="text-right">{{
                urtil.lighting
                  ? quote.region == 'us'
                    ? parseFloat($utils.mmToInch(urtil.lighting)) + 'in'
                    : urtil.lighting + 'mm'
                  : 'N/A'
              }}</v-col>
              <v-col cols="1" class="text-right">{{
                urtil.shelving ? urtil.shelving + ' x ' + getShelvingQty(urtil) : 'N/A'
              }}</v-col>
            </v-row>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <!-- PANTRIES -->
        <v-expansion-panel v-if="version.pantries && version.pantries.length > 0" :disabled="$vuetify.display.xs">
          <v-expansion-panel-title class="px-0 py-2 py-sm-4" hide-actions>
            <v-container fluid class="py-2">
              <v-row>
                <v-col :cols="discountApplied ? 10 : 8" sm="8">
                  <div class="text-sm-truncate text-body-2 text-sm-body-1">
                    <v-icon class="hidden-xs mr-1">mdi-chevron-down</v-icon
                    >{{ version.pantries.length === 1 ? 'Pantry' : 'Pantries' }}
                    <span class="hidden-xs text-accent"> (click for itemised list)</span>
                  </div>
                </v-col>
                <v-col cols="4" sm="1" v-if="version.discount > 0 || discountApplied">
                  <div class="text-caption hidden-sm-and-up text-medium-emphasis">Price</div>
                  <div class="text-body-2">
                    {{ $numeral(version.pricing.pantries.total).format('$0,0.00') }}
                  </div>
                </v-col>
                <v-col cols="4" sm="1" v-if="version.discount > 0 || discountApplied">
                  <div class="text-caption hidden-sm-and-up text-medium-emphasis">Discount</div>
                  <div class="text-body-2">0%</div>
                </v-col>
                <v-spacer />
                <v-col cols="4" sm="1" class="text-right">
                  <div class="text-caption text-medium-emphasis hidden-sm-and-up">Subtotal</div>
                  <div>
                    {{ $numeral(version.pricing.pantries.total).format('$0,0.00') }}
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-expansion-panel-title>

          <v-expansion-panel-text v-if="$vuetify.display.smAndUp">
            <v-divider />
            <v-row class="text-caption text-truncate">
              <v-col cols="1">Name</v-col>
              <v-col cols="3">Type</v-col>
              <v-col cols="2">Dimensions W/H/D</v-col>
              <v-col cols="1">Back</v-col>
              <v-col cols="2">Base</v-col>
              <v-col cols="1" class="text-right">Lighting</v-col>
              <v-col cols="1" class="text-right">Adj. Shelves</v-col>
              <v-col cols="1" class="text-right">Fixed Shelf</v-col>
            </v-row>
            <v-divider class="mb-4" />

            <v-row v-for="pantry in version.pantries" :key="pantry.id" class="text-caption">
              <v-col cols="1" class="text-truncate">{{ pantry.name }}</v-col>
              <v-col cols="3" class="text-truncate"
                >{{ getMaterialName(pantry.carcass).split('/')[0] }} Carcass [{{
                  productData.getPantryHinge(pantry.pantryHinge).label
                }}] - {{ productData.getPantryType(pantry.pantryType).label
                }}{{ pantry.flatPack ? ' (Flat-Packed)' : '' }}
              </v-col>
              <v-col cols="2" class="text-truncate"
                >{{ pantry.w }}mm / {{ pantry.h }}mm /
                {{ pantry.pantryHinge === 'o' ? pantry.d + 14 : pantry.d }}mm</v-col
              >
              <v-col cols="1" class="text-truncate">{{
                pantry.back ? getMaterialName(pantry.back).split('/')[0] : 'N/A'
              }}</v-col>
              <v-col cols="2" class="text-truncate"
                >{{ pantry.base ? getMaterialName(pantry.base).split('/')[0] : 'N/A'
                }}{{ getMaterialSides(pantry.base) == 1 ? ' [Single-Sided]' : '' }}</v-col
              >
              <v-col cols="1" class="text-right">{{
                pantry.lighting ? `2 of W${productData.getPantryLightingWidth(pantry.w)}mm` : 'N/A'
              }}</v-col>
              <v-col cols="1" class="text-right">{{
                `2 of D${productData.getPantryShelfDepth(pantry.d, 'adj')}mm`
              }}</v-col>
              <v-col cols="1" class="text-right">{{
                `1 of D${productData.getPantryShelfDepth(pantry.d, 'fixed')}mm`
              }}</v-col>
            </v-row>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <!-- SPICE RACKS -->
        <v-expansion-panel v-if="version.spiceRacks && version.spiceRacks.length > 0" :disabled="$vuetify.display.xs">
          <v-expansion-panel-title class="px-0 py-2 py-sm-4" hide-actions>
            <v-container fluid class="py-2">
              <v-row>
                <v-col :cols="discountApplied ? 10 : 8" sm="8">
                  <div class="text-sm-truncate text-body-2 text-sm-body-1">
                    <v-icon class="hidden-xs mr-1">mdi-chevron-down</v-icon
                    >{{ version.spiceRacks.length === 1 ? 'Spice Rack' : 'Spice Racks' }}
                    <span class="hidden-xs text-accent"> (click for itemised list)</span>
                  </div>
                </v-col>
                <v-col cols="4" sm="1" v-if="version.discount > 0 || discountApplied">
                  <div class="text-caption hidden-sm-and-up text-medium-emphasis">Price</div>
                  <div class="text-body-2">
                    {{ $numeral(version.pricing.spiceRacks?.total || 0).format('$0,0.00') }}
                  </div>
                </v-col>
                <v-col cols="4" sm="1" v-if="version.discount > 0 || discountApplied">
                  <div class="text-caption hidden-sm-and-up text-medium-emphasis">Discount</div>
                  <div class="text-body-2">0%</div>
                </v-col>
                <v-spacer />
                <v-col cols="4" sm="1" class="text-right">
                  <div class="text-caption text-medium-emphasis hidden-sm-and-up">Subtotal</div>
                  <div>
                    {{ $numeral(version.pricing.spiceRacks?.total || 0).format('$0,0.00') }}
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-expansion-panel-title>

          <v-expansion-panel-text v-if="$vuetify.display.smAndUp">
            <v-divider />
            <v-row class="text-caption text-truncate">
              <v-col cols="2">Name</v-col>
              <v-col cols="2">Frame</v-col>
              <v-col cols="2">Dowel</v-col>
              <v-col cols="2">Shelves</v-col>
              <v-col cols="2">Size</v-col>
              <v-col cols="2">Dimensions (mm) [W/H/D]</v-col>
            </v-row>
            <v-divider class="mb-4" />

            <v-row v-for="spiceRack in version.spiceRacks" :key="spiceRack.id" class="text-caption">
              <v-col cols="2" class="text-truncate">{{ spiceRack.name || '-' }}</v-col>
              <v-col cols="2" class="text-truncate">{{ getMaterialName(spiceRack.frame).split('/')[0] || '-' }}</v-col>
              <v-col cols="2" class="text-truncate">{{ getSpiceRackDowelLabel(spiceRack.dowel) }}</v-col>
              <v-col cols="2" class="text-truncate">{{ spiceRack.shelves || '-' }}</v-col>
              <v-col cols="2" class="text-truncate">{{ getSpiceRackSizeLabel(spiceRack.size) }}</v-col>
              <v-col cols="2" class="text-truncate">{{ spiceRack.w }} x {{ spiceRack.h }} x {{ spiceRack.d }}</v-col>
            </v-row>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-container fluid class="py-2">
        <!-- ADDITIONAL ITEMS -->
        <v-row
          v-for="item in version.additionalItems"
          :key="item.id"
          class="py-2 py-sm-4"
          :style="{ 'border-top': 'solid 1px #eee' }"
        >
          <v-col :cols="discountApplied ? 10 : 8" sm="8">
            <div class="text-sm-truncate text-body-2 text-sm-body-1">
              {{ item.description }}
            </div>
          </v-col>
          <v-col cols="4" sm="1" v-if="version.discount > 0 || discountApplied">
            <div class="text-caption text-medium-emphasis hidden-sm-and-up">Price</div>
            <div class="text-body-2">
              {{ $numeral(parseFloat(item.value)).format('$0,0.00') }}
            </div>
          </v-col>
          <v-col cols="4" sm="1" v-if="version.discount > 0 || discountApplied">
            <div class="text-caption text-medium-emphasis hidden-sm-and-up">Discount</div>
            <div class="text-body-2">{{ item.discount ? item.discount : 0 }}%</div>
          </v-col>
          <v-spacer />
          <v-col cols="4" sm="1" class="text-right">
            <div class="text-caption text-medium-emphasis hidden-sm-and-up">Subtotal</div>
            <div class="text-body-2">
              {{ $numeral(parseFloat(item.value * (1 - item.discount / 100))).format('$0,0.00') }}
            </div>
          </v-col>
        </v-row>

        <!-- Extra Info (Handle, Backs, Bases, Doors)  -->
        <v-row class="py-2 py-sm-4" :style="{ 'border-top': 'solid 1px #eee' }" v-if="summaryItems.length > 0">
          <v-col cols="12" sm="4">
            <div class="text-caption text-medium-emphasis">Detailed Summary</div>
            <div class="text-sm-truncate text-body-2 pt-2" v-for="item in summaryItems" :key="item.id">
              {{ item.type }}{{ item.materialInfo }}
            </div>
          </v-col>
        </v-row>

        <!-- TOTALS -->
        <v-row v-if="quote.region === 'uk'" class="totals">
          <v-col cols="12" sm="4" offset-sm="8">
            <v-divider class="pt-8" />
            <v-row>
              <v-col cols="6">Subtotal</v-col>
              <v-col cols="6" class="text-right">{{ $numeral(version.pricing.subtotal).format('$0,0.00') }}</v-col>
            </v-row>
            <v-row
              v-if="
                version.pricing.discountedSubtotal >= 0 &&
                $utils.toFixedNumber(version.pricing.subtotal, 2) !==
                  $utils.toFixedNumber(version.pricing.discountedSubtotal, 2)
              "
            >
              <v-col cols="6">Less Discounts</v-col>
              <v-col class="text-right">{{ $numeral(version.pricing.discountedSubtotal).format('$0,0.00') }}</v-col>
            </v-row>
            <v-row v-else-if="!version.pricing.discountedSubtotal && version.discount > 0">
              <v-col cols="6">Less {{ version.discount }}% discount</v-col>
              <v-col cols="6" class="text-right">{{
                $numeral(version.pricing.subtotal * (1 - version.discount / 100)).format('$0,0.00')
              }}</v-col>
            </v-row>
            <v-row>
              <v-col cols="6">Delivery</v-col>
              <v-col cols="6" class="text-right">
                {{ version.pricing.shipping === 0 ? 'Free' : $numeral(version.pricing.shipping).format('$0,0.00') }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">VAT</v-col>
              <v-col cols="6" class="text-right">{{ $numeral(version.pricing.vatAmount).format('$0,0.00') }}</v-col>
            </v-row>
            <v-divider class="my-4" />
            <v-row>
              <v-col cols="6"><b>TOTAL</b></v-col>
              <v-col cols="6" class="text-right">
                <b v-if="version.foc">Free of charge</b>
                <b v-else>{{ $numeral(version.pricing.total).format('$0,0.00') }}</b>
              </v-col>
            </v-row>
            <v-divider class="mt-4" />
          </v-col>
        </v-row>

        <v-row v-else class="totals">
          <v-col cols="12" sm="4" offset-sm="8">
            <v-divider class="pt-8" />
            <v-row>
              <v-col cols="6">Subtotal</v-col>
              <v-col cols="6" class="text-right">{{ $numeral(version.pricing.subtotal).format('$0,0.00') }}</v-col>
            </v-row>
            <v-row
              v-if="
                version.pricing.discountedSubtotal && version.pricing.subtotal !== version.pricing.discountedSubtotal
              "
            >
              <v-col cols="6">Less Discounts</v-col>
              <v-col cols="6" class="text-right">{{
                $numeral(version.pricing.discountedSubtotal).format('$0,0.00')
              }}</v-col>
            </v-row>
            <v-row v-else-if="!version.pricing.discountedSubtotal && version.discount > 0">
              <v-col cols="6">Less {{ version.discount }}% discount</v-col>
              <v-col cols="6" class="text-right">{{
                $numeral(version.pricing.subtotal * (1 - version.discount / 100)).format('$0,0.00')
              }}</v-col>
            </v-row>
            <v-row>
              <v-col cols="6">Delivery</v-col>
              <v-col cols="6" class="text-right">
                <template v-if="version.deliveryOverride === 'free'">FREE DELIVERY</template>
                <template v-else-if="version.deliveryOverride === 'collection'">CUSTOMER COLLECTION</template>
                <template v-else>{{
                  version.pricing.shipping === 0 ? 'Free' : $numeral(version.pricing.shipping).format('$0,0.00')
                }}</template>
              </v-col>
            </v-row>
            <v-divider class="my-4" />
            <v-row class="total">
              <v-col cols="6"><b>TOTAL (excluding taxes)</b></v-col>
              <v-col cols="6" class="text-right">
                <b v-if="version.foc">Free of charge</b>
                <b v-else>{{ $numeral(version.pricing.total).format('$0,0.00') }}</b>
              </v-col>
            </v-row>
            <v-row class="total" v-if="version.pricing.salesTax && !version.foc">
              <v-col cols="6"><b>Sales Tax</b></v-col>
              <v-col cols="6" class="text-right">
                <b v-if="version.foc">Free of charge</b>
                <b v-else>{{ $numeral(version.pricing.salesTax.amount_to_collect).format('$0,0.00') }}</b>
              </v-col>
            </v-row>
            <v-divider class="mt-4" />
          </v-col>
        </v-row>

        <!-- Payments -->
        <v-row v-if="order && order.payments.length > 0">
          <v-col cols="12" sm="4" offset-sm="8">
            <v-row>
              <v-col cols="6">Payments</v-col>
              <v-col cols="6" class="text-right">
                <div class="pb-4" v-for="(payment, index) in order.payments" :key="index">
                  {{ $numeral(payment.amount).format('$0,0.00') }}
                </div>
              </v-col>
            </v-row>
            <v-divider class="mb-4" />
            <v-row class="total">
              <v-col cols="6"><b>Balance Due</b></v-col>
              <v-col cols="6" class="text-right"
                ><b>{{ $numeral(balanceDue).format('$0,0.00') }}</b></v-col
              >
            </v-row>
            <v-divider class="mt-4" />
          </v-col>
        </v-row>

        <v-row
          v-if="
            version.notes ||
            version.earlySpacers ||
            version.earlyWorktops ||
            worktopNote.hasDogleg ||
            worktopNote.hasUpstand ||
            quote.region === 'eu'
          "
        >
          <v-col cols="12" sm="4">
            <div>Notes</div>
            <ul>
              <li v-if="quote.region === 'eu' && estimatedImportVat">
                Estimated import tax
                {{ $numeral(estimatedImportVat).format('$0,0.00') }}
              </li>
              <li v-if="version.notes">{{ version.notes }}</li>
              <li v-if="worktopNote.hasDogleg">Worktop(s) include dogleg section</li>
              <li v-if="worktopNote.hasUpstand">Worktop(s) include upstand section</li>
              <li v-if="version.earlySpacers">Spacer panels to be delivered early</li>
              <li v-if="version.earlyWorktops">Worktops to be delivered early</li>
            </ul>
          </v-col>
        </v-row>

        <v-row v-if="version.changeStatement">
          <v-col cols="12" sm="4">
            <div>Changes Made</div>
            <ul>
              <li>{{ version.changeStatement }}</li>
            </ul>
          </v-col>
        </v-row>
      </v-container>

      <!-- Customer CAD Component - only visible during print -->
      <div v-if="showVisualForPdf" class="mt-8 cad-print-container">
        <h2 class="mb-4">Visual Layout</h2>
        <CustomerCad
          :version="version"
          :quote="quote"
          :customerView="true"
          :disableControls="true"
          :inline="true"
          :printMode="showVisualForPdf"
        />
      </div>
    </div>
  </div>
</template>

<script>
import productData from '@/js/productData'
import store from '@/store'
import CustomerCad from '@/components/CustomerCad.vue'
import { db } from '@/js/db'
import { doc, getDoc } from 'firebase/firestore'

export default {
  name: 'QuoteView',
  components: {
    CustomerCad
  },
  props: ['quote', 'order', 'version', 'customerEmail', 'customerView'],
  data() {
    return {
      productData: productData,
      estimatedImportVat: null,
      openLists: [],
      showVisualForPdf: false
    }
  },
  async created() {
    var currency = !this.version.currency ? 'GBP' : this.version.currency
    this.$numeral.locale(currency)
    this.runLegacyCheck()

    if (this.quote.region === 'eu') {
      const shippingZone = await getDoc(doc(db, 'shippingZones', this.version.deliveryLocation))
      if (shippingZone.exists()) {
        this.estimatedImportVat = this.version.pricing.total * (shippingZone.data().importVat / 100)
      }
    }
  },
  watch: {
    version: {
      handler() {
        var currency = !this.version.currency ? 'GBP' : this.version.currency
        this.$numeral.locale(currency)
      },
      deep: true
    }
  },
  computed: {
    showTbcBanner() {
      // Check if user has quote permissions
      const hasPermission = this.$store.state.user?.permissions?.quote
      if (!hasPermission) return false

      // Check if any material is TBC
      const materialTbc = this.version?.materials?.some((material) => {
        return material.colourCode?.toLowerCase().includes('tbc')
      })

      // Check if any worktop is TBC
      const worktopTbc = this.version?.worktops?.some((worktop) => {
        return worktop.colourCode?.toLowerCase().includes('tbc')
      })

      return materialTbc || worktopTbc
    },
    displayCustomerEmail() {
      // Use order.customerEmail if order exists, otherwise fall back to quote customerEmail
      return this.order && this.order.customerEmail ? this.order.customerEmail : this.customerEmail
    },
    frontsQuoteList() {
      const frontsQuoteListArray = []
      this.version.fronts.forEach((front) => {
        if (front.frontType.includes('-') && front.frontType.split('-')[2] == 'cnr') {
          // create special front Obj for door, narrowFiller & wideFiller
          let cabinet = front.frontType.split('-')[1]

          let cnrFrontArray = [
            {
              frontType: front.frontType,
              w: front.w,
              h: front.h,
              handle: front.handle,
              itemNum: front.itemNum,
              material: front.material,
              qty: 1,
              id: front.uid
            },
            {
              frontType: front.frontType,
              w:
                this.quote.region == 'uk' && cabinet == 'w'
                  ? 100
                  : this.quote.region == 'uk' && cabinet != 'w'
                  ? 60
                  : this.quote.region == 'us' && cabinet == 'w'
                  ? 102
                  : 51,
              h: front.h,
              itemNum: front.itemNum,
              material: front.material,
              qty: 1,
              id: front.uid + '-nf',
              specialLabel: 'Narrow corner filler'
            },
            {
              frontType: front.frontType,
              w:
                this.quote.region == 'uk' && cabinet == 'w'
                  ? 120
                  : this.quote.region == 'uk' && cabinet != 'w'
                  ? 80
                  : this.quote.region == 'us' && cabinet == 'w'
                  ? 127
                  : 70,
              h: front.h,
              itemNum: front.itemNum,
              material: front.material,
              qty: 1,
              id: front.uid + '-wf',
              specialLabel: 'Wide corner filler'
            }
          ]
          cnrFrontArray.forEach((cnrUnit) => frontsQuoteListArray.push(cnrUnit))
        } else {
          let frontObj = {
            frontType: front.frontType,
            w: front.w,
            h: front.h,
            handle: front.handle,
            itemNum: front.itemNum,
            material: front.material,
            qty: front.qty,
            id: front.uid,
            joiningPos: front?.joiningPos,
            joiningDouble: front?.joiningDouble
          }
          frontsQuoteListArray.push(frontObj)
        }
      })
      return frontsQuoteListArray
    },
    discountApplied() {
      var b = false
      if (this.version.discount > 0 || this.version.discountWorktops > 0) {
        b = true
      }
      // check additional items
      if (this.version.additionalItems) {
        for (var i = 0; i < this.version.additionalItems.length; i++) {
          if (this.version.additionalItems[i].discount > 0) {
            b = true
          }
        }
      }
      return b
    },
    balanceDue() {
      if (!this.order) return null
      const total =
        this.order.region === 'us' && this.version.pricing.salesTax
          ? this.version.pricing.total + this.version.pricing.salesTax.amount_to_collect
          : this.version.pricing.total
      // Same helper as Checkout.balanceDue so the customer is never quoted two different figures.
      return this.$utils.calculateBalanceDue(total, this.order.payments)
    },
    requiredMaterialInfo() {
      let materialRequired = this.version.materials.filter((material) => {
        if (this.version.pricing?.fronts[material.id] && this.version.pricing.fronts[material.id].total > 0) {
          return material
        }
      })
      return materialRequired
    },
    summaryItems() {
      let summaryItems = []
      let insertHandles = []
      let remainingHandles = []

      for (const material of this.version.materials) {
        // find handles
        if (material.thickness == 4 && this.version.handles) {
          let matchingHandles = this.version.handles.filter((handle) => handle.insert == material.id)

          // reduce matchingHandles to only unique handles where if insert and value is the same then just keep one
          matchingHandles = matchingHandles.filter(
            (handle, index, self) =>
              index === self.findIndex((t) => t.insert === handle.insert && t.value === handle.value)
          )
          matchingHandles.forEach((match) => insertHandles.push(match))
        }

        // find Urtil Doors
        if (material.thickness == 6 && this.version.urtils) {
          let item = {
            materialInfo: '',
            type: ''
          }

          let matchingUrtilDoor = this.version.urtils.find(
            (urtil) => urtil.material1 == material.id || urtil.material2 == material.id
          )

          if (matchingUrtilDoor) {
            let materialLabel

            // catch glass door material
            if (['Reeded Glass Frosted Frosted', 'Reeded Glass Clear Clear'].includes(material.label)) {
              let lastIndex = material.label.lastIndexOf(' ')
              materialLabel = material.label.substring(0, lastIndex)
            } else {
              materialLabel = material.label
            }

            item.materialInfo = `${materialLabel}`
            item.type = `Urtil Door in `

            summaryItems.push(item)
          }
        }

        // find Urtil Backs
        if (material.thickness == 6 && this.version.urtils) {
          let item = {
            materialInfo: '',
            type: ''
          }
          let matchingUrtilBacks = this.version.urtils.find((urtil) => urtil.back == material.id)

          if (matchingUrtilBacks) {
            item.materialInfo = `${material.label}`
            item.type = `Urtil Back in `

            summaryItems.push(item)
          }
        }

        // find Pantry Backs
        if (material.thickness == 6 && this.version.pantries) {
          let item = {
            materialInfo: '',
            type: ''
          }
          let matchingPantryBacks = this.version.pantries.find((pantry) => pantry.back == material.id)

          if (matchingPantryBacks) {
            item.materialInfo = `${material.label}`
            item.type = 'Pantry Back in '

            summaryItems.push(item)
          }
        }

        // find Pantry Bases
        if (material.thickness == 18 && this.version.pantries) {
          let item = {
            materialInfo: '',
            type: ''
          }
          let matchingPantryLamBase = this.version.pantries.find(
            (pantry) => pantry.carcass != pantry.base && pantry.base == material.id
          )

          if (matchingPantryLamBase) {
            item.materialInfo = `${material.label}`
            item.type = `Pantry Base in `

            summaryItems.push(item)
          }
        }
      }

      if (insertHandles.length > 0 && this.version.handles) {
        // include insert handles
        insertHandles.forEach((handleType) => {
          let item = {
            materialInfo: '',
            type: ''
          }
          let handleMaterial = this.version.materials.find((material) => material.id == handleType.insert)
          item.materialInfo = ` in ${handleMaterial.label}`
          let handleTypeName = handleType.label.split('/')[0]
          item.type = handleTypeName.split(' - ')[1]
          summaryItems.push(item)
        })

        // find the rest of the handles
        remainingHandles = this.version.handles.filter((handle) => !insertHandles.includes(handle) && !handle.insert)
      } else {
        remainingHandles = this.version.handles
      }

      // include non-insert handles
      if (remainingHandles.length > 0) {
        remainingHandles.forEach((handleType) => {
          let item = {
            materialInfo: '',
            type: ''
          }
          item.materialInfo = ''
          item.type = handleType.label == 'None' ? 'Fronts with No Handle' : handleType.label
          summaryItems.push(item)
        })
      }

      // find joining brackets
      let joiningBracketCount = 0
      this.version.fronts.forEach((front) => {
        if (front.joiningPos) {
          let handleType = this.version.handles.filter((handle) => front.handle == handle.id)
          if (!['j', 'invisipull-short'].includes(handleType[0].value)) {
            switch (front.joiningPos) {
              case 'top':
              case 'bot':
                joiningBracketCount += front.qty
                break
              case 'mid':
                joiningBracketCount += front.qty * 2
                break
            }
          }
        }
      })
      if (joiningBracketCount > 0) {
        summaryItems.push({
          type: 'Joining Brackets x ' + joiningBracketCount,
          materialInfo: ''
        })
      }

      return summaryItems.reverse()
    },
    worktopNote() {
      let worktopNote = {
        hasDogleg: false,
        hasUpstand: false
      }
      for (const worktop of this.version.worktops) {
        let sectionDogleg = worktop.sections.filter((section) => {
          if (section.dogleg) return true
        })
        let sectionUpstand = worktop.sections.filter((section) => {
          if (section.customCoreThickness) return true
        })

        if (sectionDogleg.length > 0) worktopNote.hasDogleg = true
        if (sectionUpstand.length > 0) worktopNote.hasUpstand = true
      }

      return worktopNote
    }
  },
  methods: {
    byMaterial(items, materialId) {
      return (items || []).filter((item) => item.material == materialId)
    },
    isSimpleMaterialLine(material) {
      return this.quote.region === 'us' && ![24, 25, 36, 18, 4].includes(material.thickness)
    },
    getShelvingQty(urtil) {
      if (urtil.shelving && urtil.shelving !== 'fixed') {
        return urtil.shelvingOptions.qty * urtil.compartments
      } else if (urtil.shelving && urtil.shelving == 'fixed') {
        if (!urtil.preAssembled && !urtil.trimming) {
          return urtil.shelvingOptions.qty
        } else {
          return urtil.shelvingOptions.qty * urtil.compartments
        }
      }
      return 0
    },
    getMaterialSides(code) {
      const mat = this.version.materials.find((material) => {
        return code === material.id
      })
      return mat?.sides
    },
    getSpiceRackSizeLabel(value) {
      return this.productData.getSpiceRackSize(value)?.label || value || '-'
    },
    getSpiceRackDowelLabel(value) {
      return this.productData.getSpiceRackDowelMaterial(value)?.label || value || '-'
    },
    getHandleName(id) {
      for (var i = 0; i < this.version.handles.length; i++) {
        if (this.version.handles[i].id == id) {
          return this.version.handles[i].label
        }
      }
    },
    getPositionName(pos) {
      let positionName
      switch (pos) {
        case 'top':
          positionName = 'Joined Top'
          break
        case 'mid':
          positionName = 'Joined Middle'
          break
        case 'bot':
          positionName = 'Joined Bottom'
          break
      }
      return positionName
    },
    getMaterialName(code) {
      for (var i = 0; i < this.version.materials.length; i++) {
        if (code == this.version.materials[i].id) {
          var m = this.version.materials[i]
          if (['Reeded Glass Frosted Frosted', 'Reeded Glass Clear Clear'].includes(m.label)) {
            let lastIndex = m.label.lastIndexOf(' ')
            return m.label.substring(0, lastIndex)
          }
          return m.colourCode ? m.label + ' / ' + m.colourCode : m.label
        }
      }
      return ''
    },
    hasEdgeTreatment(coverPanel) {
      if (!coverPanel.edges || !coverPanel.edgeMode) return false
      const edges = coverPanel.edges
      return edges.top || edges.bottom || edges.left || edges.right
    },
    runLegacyCheck() {
      for (var i = 0; i < this.version.fronts.length; i++) {
        if (this.version.fronts[i].frontType !== productData.updateFrontIfLegacy(this.version.fronts[i].frontType)) {
          this.updateLegacyFronts()
          break
        }

        let updateInfo = productData.updateJoinedFrontIfLegacy(this.version.fronts[i].frontType)
        // console.log('updateInfo', updateInfo)
        if (this.version.fronts[i].frontType !== updateInfo.value) {
          this.updateLegacyJoinedFronts()
          break
        }
      }

      this.version.urtils.forEach((urtil) => {
        if (!urtil.compartments) {
          this.updateLegacyUrtil(urtil)
        }
      })

      if (this.version.discountWorktops === undefined) {
        this.version.discountWorktops = this.version.discount
      }
    },
    updateLegacyFronts() {
      var prevItem
      for (var i = 0; i < this.version.fronts.length; i++) {
        this.version.fronts[i].frontType = productData.updateFrontIfLegacy(this.version.fronts[i].frontType)

        // catch stacked appliance doors
        if (prevItem && prevItem.itemNum == this.version.fronts[i].itemNum) {
          if (prevItem.frontType == 'lhd-b-a' && this.version.fronts[i].frontType == 'lhd-b-a') {
            this.version.fronts[i].frontType = 'lhd-w-a'
          } else if (prevItem.frontType == 'rhd-b-a' && this.version.fronts[i].frontType == 'rhd-b-a') {
            this.version.fronts[i].frontType = 'rhd-w-a'
          }
        }
        prevItem = this.version.fronts[i]
      }
      this.$store.commit('openSnackbar', {
        snackbarText: 'Quote updated from legacy format'
      })
    },
    updateLegacyJoinedFronts() {
      // console.log(this.version.fronts)
      this.version.fronts.forEach((front, index) => {
        const checkedVal = productData.updateJoinedFrontIfLegacy(front.frontType)

        // catch qty > 1
        if (front.frontType !== checkedVal && front.qty > 1) {
          for (let i = 0; i < front.qty; i++) {
            let newFront = { ...front }
            newFront.itemNum += String.fromCharCode(97 + front.qty - 1 - i).toUpperCase()
            newFront.uid += String.fromCharCode(97 + front.qty - 1 - i).toUpperCase()
            newFront.qty = 1
            newFront.frontType = checkedVal.value
            newFront.joiningPos = checkedVal.joiningPos
            this.version.fronts.push(newFront)
          }
          this.version.fronts.splice(index, 1)

          this.$store.commit('openSnackbar', {
            snackbarText:
              'Legacy Quote had joined door with multiple QTY. The door has been split up to single QTY, please check manually!'
          })
        } else if (front.frontType !== checkedVal && front.qty == 1) {
          // update legacy joined values
          front.frontType = checkedVal.value
          front.joiningPos = checkedVal.joiningPos

          this.$store.commit('openSnackbar', {
            snackbarText: 'Legacy Quote with joined door has been updated'
          })
        }
      })
    },
    updateLegacyUrtil(urtil) {
      // if urtil has forceCentralSupport then need to add compartment!
      if (urtil.forceCenterSupport || urtil.w > 1000) {
        urtil.compartments = 2
        delete urtil.forceCenterSupport
        // if urtil has doors then set initial door coverage to match compartment
        if (urtil.type === 's') {
          urtil.doorCoverageOne = 1
          urtil.doorCoverageTwo = null
        } else if (urtil.type === 't') {
          urtil.doorCoverageOne = 1
          urtil.doorCoverageTwo = 1
        } else {
          urtil.doorCoverageOne = null
          urtil.doorCoverageTwo = null
        }
      } else {
        urtil.compartments = 1
        if (urtil.type === 's') {
          urtil.doorCoverageOne = 0.5
          urtil.doorCoverageTwo = null
        } else if (urtil.type === 't') {
          urtil.doorCoverageOne = 0.5
          urtil.doorCoverageTwo = 0.5
        } else {
          urtil.doorCoverageOne = null
          urtil.doorCoverageTwo = null
        }
      }

      this.$store.commit('openSnackbar', {
        snackbarText: 'Legacy Quote with Urtil updated with compartments!'
      })
    },
    findWorktopColourName(worktop) {
      if (!this.version?.worktops) return []

      let worktopInfo
      if (!store) return null
      if (store.state.materials) {
        const colouredMaterials = store.state.materials?.filter((material) => material.colours)
        const colours = colouredMaterials?.map((colouredMaterial) => colouredMaterial.colours)
        for (const materialSet of colours) {
          for (const colourInfo of materialSet) {
            if (colourInfo.value === worktop.colourCode) {
              worktopInfo = colourInfo
            }
          }
        }
        return worktopInfo.text
      } else {
        return null
      }
    },
    printPdf() {
      // count expansion panels
      let numOfExpansionPanels = 0
      numOfExpansionPanels += this.requiredMaterialInfo?.length
      this.version?.spacerPanels.length > 0 && numOfExpansionPanels++
      this.version?.worktops.length > 0 && numOfExpansionPanels++
      this.version?.urtils && this.version?.urtils.length > 0 && numOfExpansionPanels++
      this.version?.pantries && this.version?.pantries.length > 0 && numOfExpansionPanels++

      // open all lists
      this.openLists = [...Array(numOfExpansionPanels).keys()]

      // Show Visual component for printing
      this.showVisualForPdf = true

      // console.log('openLists', this.openLists)
      setTimeout(() => {
        window.print()

        // Hide Visual component and restore original state after printing
        this.showVisualForPdf = false
        this.openLists = []
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
*:not(.v-icon) {
  font-family: 'proxima-nova', sans-serif !important;
  letter-spacing: 0.5px !important;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-variant-ligatures: none;
}

.tbc-icon-container {
  width: 24px;
  height: 24px;
  background: white;
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  border-radius: 2px;
}

#quote-view {
  width: 100%;

  h1 {
    font-size: 3.125rem;
  }

  :deep(.v-expansion-panel__shadow) {
    display: none;
  }

  :deep(.v-expansion-panel-text__wrapper) {
    padding: 0 16px;
  }

  :deep(.v-expansion-panel-title__overlay) {
    display: none;
  }

  :deep(.v-expansion-panel--disabled .v-expansion-panel-title) {
    color: inherit;
  }

  .v-expansion-panel--active:not(:first-child)::after,
  .v-expansion-panel--active + .v-expansion-panel::after {
    opacity: 1;
  }

  // Edge Treatment Visual (matching worktop box style from PackingView)
  .edge-treatment-box {
    position: relative;
    width: 50%;
    height: 70px;
    border: solid grey 1px;
    display: flex;
    align-items: center;
    justify-content: center;

    .label {
      font-size: 9px;
      color: #666;
      text-align: center;
    }

    .v-input {
      position: absolute;
      margin: 0;
      min-width: 20px;
      background: white;
      align-items: center;
      justify-content: center;

      :deep(.v-selection-control__input) {
        transform: scale(0.7);
      }
    }

    .top {
      top: 0;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .bottom {
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 50%);
    }

    .edge-left {
      left: 0%;
      transform: translateX(-50%);
    }

    .edge-right {
      right: 0%;
      transform: translateX(50%);
    }
  }

  // Worktop Visual Boxes (matching Worktop.vue style)
  .worktop-box-col {
    .worktop-box {
      position: relative;
      width: 100%;
      height: 70px;
      border: solid grey 1px;
      display: flex;
      align-items: center;
      justify-content: center;

      .label {
        font-size: 9px;
        color: #666;
        text-align: center;
      }

      .label-shifted {
        font-size: 9px;
        color: #666;
        text-align: center;
        margin-left: 50%;
      }

      // Inner box for dogleg
      .innerBox {
        position: absolute;
        width: 50%;
        height: 50%;
        border-right: solid grey 1px;
        border-top: solid grey 1px;
        bottom: 0;
        transform: translateX(-50%);

        .innerLabel {
          margin-top: 5%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 8px;
          color: #666;
        }
      }

      // Checkbox positions for finishing/edge-banding
      .v-input {
        position: absolute;
        margin: 0;
        align-items: center;
        justify-content: center;

        :deep(.v-selection-control__input) {
          --v-selection-control-size: 24px;
          background: white;
          border-radius: 0;
        }

        :deep(.v-selection-control__input .v-icon) {
          transform: scale(0.7);
        }
      }

      .back {
        top: 0;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      .front {
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 50%);
      }

      .front-shifted {
        bottom: 0;
        left: 75%;
        transform: translate(-50%, 50%);
      }

      .edge-left {
        left: 0%;
        transform: translateX(-50%);
      }

      .left-shifted {
        bottom: 50%;
        left: 0%;
        transform: translateX(-50%);
      }

      .edge-right {
        right: 0%;
        bottom: 50%;
        transform: translate(50%, 50%);
      }

      .dogLong {
        top: 0%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      .dogShort {
        top: 50%;
        right: 0%;
        transform: translate(50%, -50%);
      }

      // Radius corner positions
      .bl,
      .br,
      .fr,
      .fl,
      .fl-dog,
      .fm-dog,
      .i {
        position: absolute;
        background: white;
        font-size: 10px;
        text-align: center;
        min-width: 20px;
        color: #333;
      }

      .bl {
        top: 0;
        left: 0;
        transform: translate(-50%, -50%);
      }

      .br {
        top: 0;
        right: 0;
        transform: translate(50%, -50%);
      }

      .fr {
        bottom: 0;
        right: 0;
        transform: translate(50%, 50%);
      }

      .fl {
        bottom: 0;
        left: 0;
        transform: translate(-50%, 50%);
      }

      .fl-dog {
        top: 25%;
        left: 0;
        transform: translate(-50%, 50%);
        z-index: 1;
      }

      .fm-dog {
        bottom: 0%;
        left: 50%;
        transform: translate(-50%, 50%);
        z-index: 1;
      }

      .i {
        top: 0;
        right: 0;
        transform: translate(50%, -50%);
      }

      // Dimension positions
      .depth {
        position: absolute;
        right: 0;
        transform: translateX(50%);
        background: white;
        font-size: 10px;
        text-align: center;
        min-width: 25px;
        color: #333;
      }

      .length {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 50%);
        background: white;
        font-size: 10px;
        text-align: center;
        min-width: 25px;
        color: #333;
      }

      .length-shifted {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, -50%);
        background: white;
        font-size: 10px;
        text-align: center;
        min-width: 25px;
        color: #333;
      }

      .doglegDepth {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translate(50%, -50%);
        background: white;
        font-size: 10px;
        text-align: center;
        min-width: 25px;
        color: #333;
        z-index: 1;
      }

      .doglegLength {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, -50%);
        background: white;
        font-size: 10px;
        text-align: center;
        min-width: 25px;
        color: #333;
        z-index: 1;
      }
    }
  }
}

@media print {
  // @page {
  //   size: A4 landscape;
  // }

  .cad-print-container {
    page-break-before: always;
    width: 100%;
    height: 100vh;
  }

  .cad-print-container h2 {
    text-align: center;
    margin-bottom: 20px;
  }

  .cad-print-container #customer-cad {
    width: 100%;
    height: calc(100vh - 100px);
  }

  .cad-print-container #customer-cad canvas {
    width: 100% !important;
    height: 100% !important;
  }
}
</style>
